import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { useAppTheme } from '@Components/Context';
import { FullHeightBox, AppLoader } from '@Components/Control';
import { Notification, CustomNotification, GuidedTour } from '@Components/Modal';
import { paths } from '@Components/configs';
import { Header, AuthHeader, AdminHeader } from './Header';

const Container = ({
  small,
  activePageType = 'noauth',
  location,
  companyMaintenanceSettings = null,
}) => {
  const { noAuthPages } = useAppTheme();

  const selectHeader = () => {
    if (activePageType === 'product') {
      return (
        <AuthHeader
          small={small}
          location={location}
          companyMaintenanceSettings={companyMaintenanceSettings}
        />
      );
    }

    if (activePageType === 'admin') {
      return (
        <AdminHeader
          small={small}
          location={location}
        />
      );
    }

    return (
      <Header
        small={small}
        darkHeader={Boolean(noAuthPages.darkBg && (location.pathname !== paths.sharedReport))}
      />
    );
  };

  return (
    <>
      {selectHeader()}
      <AppLoader />
      <Notification />
      <CustomNotification />
      {activePageType === 'product' && (
        <GuidedTour />
      )}
      <FullHeightBox noNav className="tour-app-container">
        <Outlet />
      </FullHeightBox>
    </>
  );
};

Container.propTypes = {
  small: PropTypes.bool.isRequired,
  activePageType: PropTypes.oneOf(['product', 'admin', 'noauth']).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  companyMaintenanceSettings: PropTypes.shape({
    showStatusMessage: PropTypes.bool.isRequired,
    statusMessage: PropTypes.string.isRequired,
    disabledPages: PropTypes.arrayOf(PropTypes.shape({
      disableReviewFeatures: PropTypes.bool.isRequired,
      disableSearchFeatures: PropTypes.bool.isRequired,
      disableResultsFeatures: PropTypes.bool.isRequired,
      expiresAt: PropTypes.string.isRequired,
    })),
  }),
};

export default Container;
